<template>
    <div class="masks">
        <p>
            {{text}}
        </p>
    </div>
</template>
<script>
import $ from "jquery"
export default {
    props:{
        text:{
            type:String,
            default:"人脸识别认证失败，请重试"
        }
    },
    mounted(){
        if(this.text==""){
            this.text="人脸识别认证失败，请重试"
        }
    }
}

</script>
<style lang="scss" scoped>
  .masks{
      position: absolute;
      z-index: 99999;
      width: 300px;
      height: 38px;
      border-radius: 4px;
      color: #fff;
      text-align: center;
      background: rgba(0, 0, 0, 0.6);
      left: 50%;
      margin-left: -50px;
      top:50%;
      margin-top: -25px;
      box-sizing: border-box;
      line-height: 38px;
      font-size: 14px;
      animation: fadeInOut 0.5s;

  }
  /*定义公共淡入淡出效果 fadenum*/
    @keyframes fadeInOut {
        0%{opacity: 0;}
        100%{opacity: 1;}
    }
     @keyframes fadeIn {
        0%{opacity: 1;}
        100%{opacity: 0;}
    }
</style>